<template>
  <div
    class="zmm-floating-menu"
    :class="{ 'zmm-floating-menu--smaller': !status && whiteMenu }">
    <div class="default-container default-container--menu">
      <div class="menu-wrapper">
        <div class="logo-menu">

          <router-link class="logo-menu-link" :to="{ name: `${lang}-home`, params: { lang } }">
            <img class="animated-logo" :class="{ 'logo-menu_hide': logoOpacity }" :src="require('@/assets/components/ZmmMenu/animated-logo.webp')" alt="Diamant Compositi Logo" height="60px">
            <img class="scritta-logo" :class="{ 'logo-menu_hide': logoOpacity }" :src="require('@/assets/components/ZmmMenu/scritta-logo.svg')" alt="Diamant Compositi Logo" height="40px">
          </router-link>

        </div>

        <!-- HAMBURGER FINO A 1024 -->
        <div
          class="hamburger-menu-container show-still-large"
          :class="{ 'coloredBackground': backgroundHamburger }"
          @click="$_hamburgerClick">

          <div
            class="hamburger-menu"
            id="hamburger"
            :class="{ 'hamburger-menu-container--animate': status }"/>
        </div>

        <!-- MENU DESKTOP DOPO 1024 -->
        <div class="menu-desktop hide-still-large">

          <ul class="menu-desktop__list">
            <li>
              <router-link :to="{ name: `${lang}-lavorazioni`, params: { lang } }">{{ $t('vociMenu.lavorazioni') }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: `${lang}-settori`, params: { lang } }">{{ $t('vociMenu.settori') }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: `${lang}-azienda`, params: { lang } }">{{ $t('vociMenu.azienda') }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: `${lang}-contatti`, params: { lang } }">{{ $t('vociMenu.contatti') }}</router-link>
            </li>
          </ul>
          <ul class="menu-desktop__languages-list">
            <li :class="{ 'router-link-active': lang === 'it' }">
              <span v-if="lang === 'it'">IT</span>
              <a v-else :href="translatedUrl" @click="handleLangClick">IT</a>
            </li>
            <li :class="{ 'router-link-active': lang === 'en' }">
              <span v-if="lang === 'en'">EN</span>
              <a v-else :href="translatedUrl" @click="handleLangClick">EN</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data: () => ({
    whiteMenu: false
  }),
  props: {
    lang: {
      type: String,
      required: true
    },
    status: {
      type: Boolean,
      default: () => false
    },
    fastWhite: {
      type: Boolean,
      default: () => false
    },
    backgroundHamburger: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    logoOpacity: {
      get () {
        return false
        // return this.$route.meta.pageName === 'menu'
      }
    },
    translatedUrl: {
      get () {
        // Raccolgo i dati principali dei lang e della rotta corrente...
        const routeName = this.$route.name
        const currentLang = this.lang
        const altLang = this.lang === 'en' ? 'it' : 'en'

        // ...poi controllo se la rotta corrente fa parte di una pagina figlia, che segue una logica diversa...
        const paramsType = this.$route && this.$route.params && this.$route.params.type
        const mappedSubroutes = {
          en: {
            'raw-material-storage': 'stoccaggio-materie-prime',
            'mold-construction': 'costruzione-stampi',
            'cutting-with-plotter-and-manual': 'taglio-con-plotter-e-manuale',
            'lamination-in-clean-room': 'laminazione-in-clean-room',
            'curing': 'cottura',
            'finishing-and-assembly': 'finitura-e-assemblaggio',
            'painting': 'verniciatura',
            'quality-control': 'controllo-qualita'
          },
          it: {
            'stoccaggio-materie-prime': 'raw-material-storage',
            'costruzione-stampi': 'mold-construction',
            'taglio-con-plotter-e-manuale': 'cutting-with-plotter-and-manual',
            'laminazione-in-clean-room': 'lamination-in-clean-room',
            'cottura': 'curing',
            'finitura-e-assemblaggio': 'finishing-and-assembly',
            'verniciatura': 'painting',
            'controllo-qualita': 'quality-control'
          }
        }
        if (paramsType) {
          // Sono ricorso a delle rotte mappate perchè non sapevo più a che santo votarmi, sorry
          const mappedTranslatedSlug = mappedSubroutes[this.lang][paramsType]
          return this.$router.resolve({ name: _.replace(routeName, `${currentLang}-`, `${altLang}-`), params: { type: mappedTranslatedSlug } }).href
        }

        // ...altrimenti procedo con la conversione normale.
        return this.$router.resolve({ name: _.replace(routeName, `${currentLang}-`, `${altLang}-`) }).href
      }
    }
  },
  methods: {
    $_hamburgerClick () {
      if (['menu'].includes(this.$route.meta.pageName)) this.$router.back()
      else this.$router.push({ name: `${this.lang}-menu` })
    },
    $_updateScroll () {
      this.whiteMenu = (this.fastWhite && window.scrollY > 10) || window.scrollY >= window.innerHeight
      if (this.$route.meta.pageName === 'privacy-policy') this.whiteMenu = true
      if (this.$route.meta.pageName === 'not-found') this.whiteMenu = true
      if (this.$route.meta.pageName === 'cookie-policy') this.whiteMenu = true
    },
    $_convertRoute (routeName, currentLang, lang) {
      // Metodo disattivato, ho spostato tutto sulla computed translatedUrl
      return this.$router.resolve({ name: _.replace(routeName, `${currentLang}-`, `${lang}-`) }).href
    },
    handleLangClick () {
      const oppositeLang = this.lang === 'it' ? 'en' : 'it'
      localStorage.setItem('selectedLanguage', oppositeLang)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.$_updateScroll)
    if (this.$route.meta.pageName === 'privacy-policy') this.whiteMenu = true
    if (this.$route.meta.pageName === 'not-found') this.whiteMenu = true
    if (this.$route.meta.pageName === 'cookie-policy') this.whiteMenu = true
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.$_updateScroll)
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .show-still-large{
    display: block;
  }
  .hide-still-large{
    display: none;
  }

  .logo-menu{
    display: inline-block;

    a {
      display: flex;
    }

    .animated-logo {
      height: 35px;
    }
    .scritta-logo {
      height: 35px;
      margin-left: 5px;
    }

    svg, img{
      display: block;
      opacity: 1;
      transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    svg.logo-menu_hide, img.logo-menu_hide {
      opacity: 0;
    }

    @media #{$medium_mq} {
      .animated-logo {
        height: 60px;
      }
      .scritta-logo {
        height: 60px;
        margin-left: 10px;
      }
    }
  }

  @media #{$large_mq} {
    .show-still-large{
      display: none;
    }
    .hide-still-large{
      display: block;
    }
  }

  .zmm-floating-menu {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: transparent;

  .default-container--menu{
    background-color: #262624;
    padding-top: 20px;
    padding-bottom: 20px;
    transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);

    @media #{$large_mq} {
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }
  &.zmm-floating-menu--smaller .default-container--menu{
    padding-top: 20px;
    padding-bottom: 20px;
  }
}

.zmm-floating-menu, .zmm-floating-menu .hamburger-menu:before, .zmm-floating-menu .hamburger-menu:after, .zmm-floating-menu .logo-menu path{
  transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1)
}

.menu-wrapper{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}

.hamburger-menu-container{
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 35px;
  height: 55px;
  cursor: pointer;
}

.hamburger-menu{
  width: 35px;
  height: 43px;
  top: 25px;
}

.hamburger-menu,
.hamburger-menu:after,
.hamburger-menu:before {
  width: 35px;
  height: 2px;
}

.hamburger-menu {
  position: relative;
  background: #FFF;
  transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
}
.hamburger-menu.hamburger-menu-container--animate {
  background: rgba(255, 255, 255, 0);
}

.hamburger-menu:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 10px;
  background: #FFF;
  transition: bottom 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu:after {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  background: #FFF;
  transition: top 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu.hamburger-menu-container--animate:after {
  top: 0;
  transform: rotate(45deg);
  transition: top 300ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu.hamburger-menu-container--animate:before {
  bottom: 0;
  transform: rotate(-45deg);
  transition: bottom 300ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu-container::before{
  content: '';
  position: absolute;
  top: 50%; left: 50%; transform: translate3d(-50%, -50%, 0);
  width: 58px; height: 58px;
  background-color: #679196;
  border-radius: 29px;
  opacity: 0;
  transition: opacity 600ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu-container.coloredBackground::before {
  opacity: 1;
}

.zmm-floating-menu .menu-desktop__list{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  li{
    margin-left: 2rem;
    @media #{$xlarge_mq} {
      margin-left: 3rem;
    }
    @media #{$xxlarge_mq} {
      margin-left: 3.5rem;
    }

    a{
      font-family: 'Roboto', sans-serif;
      font-weight: 500;

      font-size: .8rem;
      letter-spacing: .1rem;
      text-transform: uppercase;
      color: #EFEFF1;
      text-decoration: none;
      transition: color 300ms cubic-bezier(0.23, 1, 0.32, 1);
      @media #{$large_mq} {
        font-size: .85rem; letter-spacing: .15rem;
      }
      @media #{$xlarge_mq} {
        font-size: .9rem; letter-spacing: .2rem;
      }
      @media #{$xxlarge_mq} {
        font-size: 1rem; letter-spacing: .2rem;
      }

    }
  }
}

@media #{$large_mq} {
  .menu-desktop{
    display: flex;
    flex-direction: row;
  }
}

.zmm-floating-menu .menu-desktop__list a::before{
  position: absolute;
  left: -5px;
  bottom: -3.8rem;
  width: 0;
  content: "";
  height: 4px;
  background-color: #679196;
  transition: width 600ms cubic-bezier(0.23, 1, 0.32, 1);
}
.zmm-floating-menu.zmm-floating-menu--smaller .menu-desktop__list a::before{
  bottom: -2.6rem;
}

.menu-desktop__list a.router-link-active::before, .menu-desktop__list a:hover::before{
  width: calc(100% + 10px);
}

.menu-desktop__languages-list{
    display: flex;
    flex-direction: column;
    width: 28px;
    text-align: left;
    margin-left: 2.5rem;

    &::after{
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      border-top: 5px solid #fff;
      right: -5px;
      top: 8px;

      @media #{$xlarge_mq} {
        top: 8px;
      }
    }

    li{
      visibility: hidden;
      order: 2;
      position: absolute;
      top: 1.2rem;
    }

    &:hover li{
      visibility: visible;
    }

    li a, li span{
      font-size: 1rem;
      text-transform: uppercase;
      color: #EFEFF1;
      text-decoration: none;
      transition: color 300ms cubic-bezier(0.23, 1, 0.32, 1);

      font-family: 'Roboto', sans-serif;
      font-weight: 500;
      font-size: .8rem;
      letter-spacing: .1rem;

      @media #{$large_mq} {
        font-size: .85rem; letter-spacing: .15rem;
      }
      @media #{$xlarge_mq} {
        font-size: .9rem; letter-spacing: .2rem;
      }
      @media #{$xxlarge_mq} {
        font-size: 1rem; letter-spacing: .2rem;
      }

    }

    li.router-link-active{
      visibility: visible;
      order: 0;
      position: relative;
      top: auto;
    }

}

</style>
